/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:46
 * @LastEditTime: 2021-04-21 10:13:56
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\headerLogo\headerLogo.js
 * @Description: 
 */
/*
    Create By lileilei 2018-01-22
    新疆维吾尔自治区媒体云平台头部logo 可通过租户修改
*/
'use strict';
angular.module('headerLogoModule', []).directive('headerLogo', ['$rootScope', 'globleParamsSet', function($rootScope, globleParamsSet) {
    return {
        restrict: 'EA',
        scope: {
            name: '@',
        },
        templateUrl: './components/util/headerLogo/headerLogo.html',
        link: function(scope) {
            initTenantLogo();

            /**
             * [initTenantLogo description] //初始化租户logo
             * @return {[type]} [description]
             */
            function initTenantLogo() {
                globleParamsSet.getTenantLogo().then(function(data) {
                    scope.headerLogoUrl = data.LOGO_1;
                    scope.name = data.INTRO ? data.INTRO : scope.name;
                });
            }
            $rootScope.$on('updateTenantLogo', function(event, data) {
                updateLogoTitle(data.name, data.url);
            });
            window.addEventListener('storage', updateLogoTitleForLinstener);
            scope.$on('$destroy', function() {
                window.removeEventListener('storage', updateLogoTitleForLinstener);
            });

            /**
             * [updateLogoTitleForLinstener description] 跨页面监控更新
             * @param  {[type]} e [description]
             * @return {[type]}   [description]
             */
            function updateLogoTitleForLinstener(e) {
                if (e.key === 'updateTenantLogo') {
                    var data = JSON.parse(e.newValue);
                    updateLogoTitle(data.name, data.url);
                }
            }

            /**
             * [updateLogoTitle description] 普通更新
             * @param   {[type]}  title  [title description]
             * @param   {[type]}  src    [src description]
             * @return  {[type]}         [return description]
             */
            function updateLogoTitle(title, src) {
                if (title) {scope.name = title;}
                if (src) {
                    scope.headerLogoUrl = src;
                }
            }
        }
    };
}]);
